/** Supported interface languages. The language always comes from the URL. */
export const LANGS = ["nl", "en", "fr"] as const;

export type Lang = (typeof LANGS)[number];

export const DEFAULT_LANG: Lang = "nl";

/**
 * Talen die altijd indexeerbaar zijn. Voor en en fr volgt dat sinds fase H2 uit de inhoud:
 * een taal komt pas in de index en de sitemap wanneer elke pagina erin gepubliceerd is.
 */
export const INDEXABLE_LANGS: readonly Lang[] = ["nl"];


export const LANG_LABELS: Record<Lang, string> = {
  nl: "Nederlands",
  en: "English",
  fr: "Français",
};

export function isLang(value: unknown): value is Lang {
  return typeof value === "string" && (LANGS as readonly string[]).includes(value);
}

/** Hydration may skip beforeLoad; initialize translated chrome from the same URL as SSR. */
export function languageFromPath(pathname: string): Lang {
  const segment = pathname.split("/")[1];
  return isLang(segment) ? segment : DEFAULT_LANG;
}
